import { render } from "./gas.svg?vue&type=template&id=25cb8e20"
const script = {}

import exportComponent from "F:\\Norwood dev theme\\norwood-dev-sawmills\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__